/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Tut_Rut_S1Inputs */

const en_mk_tut_rut_s1 = /** @type {(inputs: Mk_Tut_Rut_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open **Routines**, press **New routine**, and give it a title like *Morning sales recap*.`)
};

const id_mk_tut_rut_s1 = /** @type {(inputs: Mk_Tut_Rut_S1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Buka menu **Rutinitas**, tekan **Rutinitas baru**, beri judul seperti *Rekap penjualan pagi*.`)
};

/**
* | output |
* | --- |
* | "Open **Routines**, press **New routine**, and give it a title like *Morning sales recap*." |
*
* @param {Mk_Tut_Rut_S1Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_rut_s1 = /** @type {((inputs?: Mk_Tut_Rut_S1Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_Rut_S1Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_rut_s1(inputs)
	return en_mk_tut_rut_s1(inputs)
});